class PaneraFeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.collectionUrl = this.dataset.collectionUrl;
    this.currentSort = new URLSearchParams(window.location.search).get('sort_by') || 'created-descending';

    const radio = this.querySelector(`input[name="sort-${this.sectionId}"][value="${this.currentSort}"]`);
    if (radio) radio.checked = true;

    this.querySelectorAll(`input[name="sort-${this.sectionId}"]`).forEach((input) => {
      input.addEventListener('change', (event) => {
        this.fetchSort(event.target.value);
        history.pushState({}, '', `?sort_by=${event.target.value}`);
      });
    });

    if (this.currentSort) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.fetchSort(this.currentSort), { once: true });
      } else {
        this.fetchSort(this.currentSort);
      }
    }
  }

  fetchSort(sortValue) {
    const gridContainer = this.querySelector(`#PaneraProductGrid-${this.sectionId}`);
    if (!gridContainer) return;
    gridContainer.classList.add('loading');
    fetch(`${this.collectionUrl}?section_id=${this.sectionId}&sort_by=${sortValue}`)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.getElementById(`PaneraProductGrid-${this.sectionId}`);
        if (newGrid) gridContainer.innerHTML = newGrid.innerHTML;
        gridContainer.classList.remove('loading');
      })
      .catch(() => gridContainer.classList.remove('loading'));
  }
}

customElements.define('panera-featured-collection', PaneraFeaturedCollection);
